const LABEL_MAP = {
  COMPUTER_INACCESSIBLE: 'Computer Inaccessible',
  FHMS_CRASHED: 'FHMS Crashed',
  LOW_DISK_SPACE: 'Low Disk Space',
  IDTECH_CARD_READER: 'IDTech Card Reader',
  CRADLEPOINT_INACCESSIBLE: 'Cradlepoint Inaccessible',
  TOUCHSCREEN: 'Touchscreen',
  FROZEN_TOUCHSCREEN: 'Frozen Touchscreen',
  STATUS_5_MOTOR_FAULT: 'Motor Fault',
  MAGTEK_CARD_READER: 'Magtek Card Reader',
  STATUS_G_THERMOMETER_DISCONNECT: 'Thermometer Disconnect',
  STATUS_C_ELEVATOR_APPROACHING_A_POSITION: 'Elevator Approaching A Position',
  STATUS_6_BELT_FAULT: 'Belt Fault',
  STATUS_9_PRODUCT_DETECT_FAULT: 'Product Detect Fault',
  STATUS_A_BUS_FAULT: 'Bus Fault',
  JOFEMAR_DISCONNECTED: 'Jofemar Disconnected',
  FOOD_SAFETY: 'Food Safety',
  HIGH_TEMPERATURE_ALERT: 'High Temperature Alert',
  OUT_OF_ORDER: 'Out Of Order',
  STATUS_B_PRODUCT_UNDER_ELEVATOR: 'Product Under Elevator',
  STATUS_K_ELEVATOR_DOES_NOT_FIND_TRAY_CHANNEL:
    'Elevator Does Not Find Tray Channel',
  LAYOUT_NOT_MATCH: 'Layout Mismatch',
  NO_TEMPERATURE_READINGS_SOFTWARE_ISSUE:
    'No Temperature Readings Software Issue',
  STATUS_FF_TIMEOUT: 'Timeout',
  STATUS_FF_SERIAL_DISCONNECT: 'Serial Disconnect',
  STOCK_REMOVAL: 'Stock Removal',
  FROZEN_UI: 'Frozen UI',
  TOUCHSCREEN_USB: 'Touchscreen USB',
  TOUCHSCREEN_HDMI: 'Touchscreen HDMI',
};

export default function getFixTypeLabel(fixType) {
  if (!fixType) return 'Unknown Issue';

  const base = fixType.split('#')[0];

  if (LABEL_MAP[base]) {
    return LABEL_MAP[base];
  }

  return base
    .replace(/^STATUS_[A-Z0-9]+_/, '')
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

export const FIX_TYPE_OPTIONS = Object.keys(LABEL_MAP)
  .map((key) => ({ value: key, label: LABEL_MAP[key] }))
  .sort((a, b) => a.label.localeCompare(b.label));
